import { render, staticRenderFns } from "./create-invoice.vue?vue&type=template&id=c16bf6d0&scoped=true"
import script from "./create-invoice.vue?vue&type=script&lang=js"
export * from "./create-invoice.vue?vue&type=script&lang=js"
import style0 from "./create-invoice.vue?vue&type=style&index=0&id=c16bf6d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16bf6d0",
  null
  
)

export default component.exports